import {
  EnterPromoCodeResponse,
  GetPriceListResponse,
  Invoice,
  InvoiceHistoryResponse,
  InvoiceResponse,
  PromoCodeBase,
  StripeInvoice,
  StripeInvoiceResponse,
  UserInvoiceHistoryData,
} from '@/api';
import { PriceListPlansData } from '../models';

const fetchPriceListPlans = (
  response: GetPriceListResponse,
): PriceListPlansData => {
  const { data } = response;
  return data;
};

const fetchInvoiceHistory = (
  response: InvoiceHistoryResponse,
): UserInvoiceHistoryData => {
  return response.data;
};

const enterPromoCode = (response: EnterPromoCodeResponse): PromoCodeBase => {
  return response.data;
};
const createStripeInvoice = (
  response: StripeInvoiceResponse,
): StripeInvoice => {
  return response.data;
};

const createCryptoInvoice = (response: InvoiceResponse): Invoice => {
  return response.data;
};

export {
  fetchPriceListPlans,
  createStripeInvoice,
  createCryptoInvoice,
  fetchInvoiceHistory,
  enterPromoCode,
};
